<!--  -->
<template>
<div class="full-screen">
  <iframe :src="$data.link"></iframe>
  <div class="bt-button">
    <img @click="playAudio()" :src="audio2?require('@/assets/img/audio-on.png'):require('@/assets/img/audio-off.png')" alt="">
    <img @click="closeFullSreen()" src="@/assets/img/close-full.png" alt="">
  </div>
  
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  audio2: this.$store.state.audio
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
  '$store.state.audio'() {
    this.audio2 = this.$store.state.audio
  }
},
//方法集合
methods: {
  playAudio() {
    if(!this.$audio.paused) {
      this.$audio.pause();
      this.audio2 = false;
    }else {
      this.$audio.play();
      this.audio2 = true;
    }
    this.$store.commit('changeAudio', this.audio2);
  },
closeFullSreen() {
    document.body.removeChild(this.$el);
    this.$destroy();

}
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.full-screen {
  width:100%;
  height:100%;
  position:fixed;
  top:0;
  left:0;
  z-index:9999;
  iframe {
    width:100%;
    height:100%;
  }
  .bt-button {
  display:block;
  position:absolute;
  right:10px;
  bottom:10px;
  img {
    width:30px;
    margin-left:10px;
  }
}
}
</style>